import { EditGuesser, ShowGuesser } from 'react-admin'

import { YoutubeRawImportsList } from './YoutubeRawImportsList'

export const youtubeRawImports = {
  edit: EditGuesser,
  list: YoutubeRawImportsList,
  show: ShowGuesser,
}
